import { useMemo as o } from "react";
function m(e) {
  const t = o(() => [], [e]), s = o(() => e.map((n, f) => (r) => {
    t[f] = r;
  }), [e]);
  return [t, s];
}
export {
  m as default
};
